document.addEventListener("DOMContentLoaded", function () {
    const addToCartButton = document.querySelector(".button--add-to-cart");
    const addToCartContainer = addToCartButton.closest("form") || addToCartButton.parentElement;

    if (!addToCartButton || !addToCartContainer) return;

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (!entry.isIntersecting) {
                addToCartButton.classList.add("sticky");
            } else {
                addToCartButton.classList.remove("sticky");
            }
        },
        { rootMargin: "0px", threshold: 0.1 }
    );

    observer.observe(addToCartContainer);
});